import { defineStore } from 'pinia'
import type { IFeedbackStoreState } from '@/modules/feedback/types/IFeedbackStoreState'
import type { IAlertType } from '@/modules/feedback/types/IAlertType.ts'

export const useFeedbackStore = defineStore('feedbackStore', {
  state: (): IFeedbackStoreState => ({
    isGlobalLoading: false,
    toastVisible: false,
    toastMessage: '',
    toastType: 'info',
    toastDuration: 5000,
    showMainLogo: false,
  }),
  getters: {},
  actions: {
    /**
     * Показать toast-уведомление через v-snackbar
     *
     * @param type — тип уведомления (success, info, error, warning)
     * @param message — текст сообщения
     * @param time — длительность показа в мс (по умолчанию 5000)
     */
    showToast({ type, message, time }: { type: IAlertType; message: string; time?: number }) {
      this.toastType = type
      this.toastMessage = message
      this.toastDuration = time || 5000
      this.toastVisible = true
    },

    /** Скрыть текущий toast */
    hideToast() {
      this.toastVisible = false
    },
  },
})
